var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 12,
    viewBox: "0 0 72 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.04166,
    width: 63.4783,
    height: 2.03678,
    fill: "#4c39a0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3857 6.07843L61.1957 8.31889L69.8913 5.06003L61.1957 1.5975L63.3857 4.04164",
    stroke: "#4c39a0",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1956 1.5975L70 5.06004L61.1956 8.31888L63.4239 5.03017L61.1956 1.5975Z",
    fill: "#4c39a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f90e544823990675352ffc6e517fef9a.svg";
export { ForwardRef as ReactComponent };